import { useContext } from "react";

import { objectEntries, objectFromEntries, removeNullUndefined } from "@nens/shared-utils";

import { RanaFormContext } from "..";
import { RanaErrors } from "../../components/rana-errors";

const useNonFieldErrors = (displayImaginaryError: boolean) => {
  const { errors, values } = useContext(RanaFormContext);

  if (!errors || Object.keys(errors).length === 0) {
    if (displayImaginaryError) {
      return "This is a testing error";
    }
    return null;
  }

  return objectFromEntries(
    removeNullUndefined(
      objectEntries(errors).map(([key, value]) =>
        Object.keys(values).includes(key + "") ? null : [key, value]
      )
    )
  );
};

// The RanaForms submit function requires an onError function which will send any api error's back to the form
// Those errors are usually a key error value with the key corresponding to the field key.
// If the key of an error does not match a field then its a "non field error"
// and it will be displayed here.

// We also double check if this field is added to the children of the RanaForm in `useWarnNoNonFieldErrorComponent`
export function RanaFormErrors({
  displayImaginaryError = false,
}: {
  displayImaginaryError?: boolean;
}) {
  const nonFieldErrors = useNonFieldErrors(displayImaginaryError);

  return <RanaErrors errors={nonFieldErrors} />;
}
